import type {
  AddCartRecommendItem,
  GoodsLikeRecommendItem,
} from 'shared/src/api';
import type { GoodsData } from '@banhala/ui-kit';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';

export const convertGoodsLikeItemToGoodsData = (
  input: GoodsLikeRecommendItem | AddCartRecommendItem,
): GoodsData & (GoodsLikeRecommendItem | AddCartRecommendItem) => {
  return {
    ...input,
    ...convertRenderDataToGoodsData(input, {
    }),
  };
};
